import { $cms } from "@/utils/https";

// 批量创建配件检修记录
export function batchReturnRecords(data) {
    return $cms().post(`/api/cms/manage/accessory/return/record/batch`, data);
}

export function addReturnRecord(data) {
    return $cms().post(`/api/cms/manage/accessory/return/record`, data);
}

export function getReturnRecords(params) {
    return $cms().get(`/api/cms/manage/accessory/return/record`, { params });
}

export function updateReturnRecord(id, data) {
    return $cms().put(`/api/cms/manage/accessory/return/record/${id}`, data);
}

export function deleteReturnRecord(id) {
    return $cms().delete(`/api/cms/manage/accessory/return/record/${id}`);
}

export function getReturnRecord(id) {
    return $cms().get(`/api/cms/manage/accessory/return/record/${id}`);
}

// 完成
export function finishReturnRecord(id, data) {
    return $cms().put(`/api/cms/manage/accessory/return/record/${id}/finish`, data);
}

// 误判
export function misjudgmentReturnRecord(id, data) {
    return $cms().put(`/api/cms/manage/accessory/return/record/${id}/misjudgment`, data);
}

// 返修
export function repairReturnRecord(id, data) {
    return $cms().put(`/api/cms/manage/accessory/return/record/${id}/repair`, data);
}

// 统计分析
export function analyzeReturnRecords(params) {
    return $cms().get(`/api/cms/manage/accessory/return/record/analysis`, { params });
}

// 统计
export function statReturnRecords(params) {
    return $cms().get(`/api/cms/manage/accessory/return/record/stat`, { params });
}
